<template>
  <div class="task-detail">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
        />
      </a>
      <a
        href="#/TaskList"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="d-flex d-flex-first">
      <div class="flex-item">
        <label class="label">POS Code</label>
        <el-input
          style="flex: 1; margin-left: 5px"
          v-model="POSCode"
          placeholder="Please input"
          type="textarea"
          rows="1"
          @keydown.enter.native="keyDown"
        ></el-input>
      </div>
      <div class="flex-item">
        <label class="label">Team</label>
        <el-select
          v-model="Teams"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
        >
          <el-checkbox
            v-model="check_Teams"
            style="margin-left: 20px; width: 200px"
            :indeterminate="Teams.length !== TeamOptions.length"
            @change="selectAll_Teams"
            >All</el-checkbox
          >
          <el-option
            v-for="item in TeamOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Group Customer</label>
        <el-select
          v-model="GroupCustomers"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          :disabled="isDisabled('Group Customer')"
          filterable
        >
          <el-checkbox
            v-model="check_GroupCustomers"
            style="margin-left: 20px; width: 200px"
            :indeterminate="
              GroupCustomers.length !== GroupCustomerOptions.length
            "
            @change="selectAll_GroupCustomers"
            >All</el-checkbox
          >
          <el-option
            v-for="item in GroupCustomerOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Business Model</label>
        <el-select
          v-model="BusinessModels"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          :disabled="isDisabled('Business Model')"
        >
          <el-checkbox
            v-model="check_BusinessModels"
            style="margin-left: 20px; width: 200px"
            :indeterminate="
              BusinessModels.length !== BusinessModelOptions.length
            "
            @change="selectAll_BusinessModels"
            >All</el-checkbox
          >
          <el-option
            v-for="item in BusinessModelOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">POS Status</label>
        <el-select
          v-model="POSStatusCheck"
          :disabled="isDisabled('POS Status')"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
        >
          <el-checkbox
            v-model="check_POSStatusCheck"
            style="margin-left: 20px; width: 200px"
            :indeterminate="POSStatusCheck.length !== POSStatus.length"
            @change="selectAll_POSStatus"
            >All</el-checkbox
          >
          <el-option
            v-for="item in POSStatus"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Project Code</label>
        <el-input
          style="flex: 1; margin-left: 5px"
          v-model="ProjectCode"
          placeholder="Please input"
          type="textarea"
          rows="1"
          @keydown.enter.native="keyDown"
        ></el-input>
      </div>

      <div class="flex-item">
        <label class="label">Channel</label>
        <el-select
          v-model="Channels"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          @change="GetSubChannel"
          :disabled="isDisabled('Channel')"
        >
          <el-checkbox
            v-model="check_Channels"
            style="margin-left: 20px; width: 200px"
            :indeterminate="Channels.length !== ChannelOptions.length"
            @change="selectAll_Channels"
            >All</el-checkbox
          >
          <el-option
            v-for="item in ChannelOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Sub Channel</label>
        <el-select
          v-model="SubChannels"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          @change="GetFormat"
          :disabled="isDisabled('Sub Channel')"
          filterable
        >
          <el-checkbox
            v-model="check_SubChannels"
            style="margin-left: 20px; width: 200px"
            :indeterminate="SubChannels.length !== SubChannelOptions.length"
            @change="selectAll_SubChannels"
            >All</el-checkbox
          >
          <el-option
            v-for="item in SubChannelOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Format</label>
        <el-select
          v-model="Formats"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          :disabled="isDisabled('Format')"
          filterable
        >
          <el-checkbox
            v-model="check_Formats"
            style="margin-left: 20px; width: 200px"
            :indeterminate="Formats.length !== FormatOptions.length"
            @change="selectAll_Formats"
            >All</el-checkbox
          >
          <el-option
            v-for="item in FormatOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Project Status</label>
        <el-select
          v-model="ProjectStatusCheck"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          :disabled="isDisabled('Project Status')"
        >
          <el-checkbox
            v-model="check_ProjectStatusCheck"
            style="margin-left: 20px; width: 200px"
            :indeterminate="ProjectStatusCheck.length !== ProjectStatus.length"
            @change="selectAll_ProjectStatus"
            >All</el-checkbox
          >
          <el-option
            v-for="item in ProjectStatus"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Region</label>
        <el-select
          v-model="Regions"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          @change="GetProvinces"
        >
          <el-checkbox
            v-model="check_Regions"
            style="margin-left: 20px; width: 200px"
            :indeterminate="Regions.length !== RegionOptions.length"
            @change="selectAll_Regions"
            >All</el-checkbox
          >
          <el-option
            v-for="item in RegionOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Province</label>
        <el-select
          v-model="Provinces"
          multiple
          collapse-tags
          placeholder="Please select"
          @change="GetCitys"
          style="margin-left: 5px; flex: 1"
          :disabled="isDisabled('Province CN')"
          filterable
        >
          <el-checkbox
            v-model="check_Provinces"
            style="margin-left: 20px; width: 200px"
            :indeterminate="Provinces.length !== ProvinceOptions.length"
            @change="selectAll_Provinces"
            >All</el-checkbox
          >
          <el-option
            v-for="item in ProvinceOptions"
            :key="item.id"
            :label="item.nameCN"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">City</label>
        <el-select
          v-model="Citys"
          multiple
          collapse-tags
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
          :disabled="isDisabled('City CN')"
          filterable
        >
          <el-checkbox
            v-model="check_Citys"
            style="margin-left: 20px; width: 200px"
            :indeterminate="Citys.length !== CityOptions.length"
            @change="selectAll_Citys"
            >All</el-checkbox
          >
          <el-option
            v-for="item in CityOptions"
            :key="item.id"
            :label="item.nameCN"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">City Tier</label>
        <el-select
          v-model="CityTiers"
          multiple
          collapse-tags
          :disabled="isDisabled('City Tier')"
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
        >
          <el-checkbox
            v-model="check_CityTiers"
            style="margin-left: 20px; width: 200px"
            :indeterminate="CityTiers.length !== CityTierOptions.length"
            @change="selectAll_CityTiers"
            >All</el-checkbox
          >
          <el-option
            v-for="item in CityTierOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="flex-item">
        <label class="label">Action</label>
        <el-select
          v-model="ActionCheck"
          multiple
          collapse-tags
          :disabled="isDisabled('Action')"
          placeholder="Please select"
          style="margin-left: 5px; flex: 1"
        >
          <el-checkbox
            v-model="check_Action"
            style="margin-left: 20px; width: 200px"
            :indeterminate="ActionCheck.length !== Action.length"
            @change="selectAll_Action"
            >All</el-checkbox
          >
          <el-option
            v-for="item in Action"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- <div class="d-flex">
      <template>
        <div class="flex-item" v-for="(column, index) in mulchoice" :key="index">
          <label class="label">{{ column.column_Name }}</label>
          <el-select
            v-model="column.checks"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-option v-for="item in column.datas" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </template>
    </div>-->
    <div
      @click="clicksummary"
      class="summary"
      style="cursor: pointer; text-align: left"
    >
      {{ summarybutton }}
    </div>
    <div class="summary" v-if="isvosablesummary">
      <el-table
        ref="summaryTable"
        v-loading="summaryLoading"
        :data="summaryTableData"
        border
        fit
        :header-cell-style="tableHeaderCell"
        :cell-style="tableCellSummary"
      >
        <el-table-column
          v-for="item in summaryColumns"
          :key="item.field_Name"
          :prop="item.field_Name"
          :label="item.column_Name"
          :min-width="item.width"
        ></el-table-column>
      </el-table>
    </div>
    <div style="margin: auto; width: 90%; margin-top: 10px; display: flow-root">
      <div
        style="height: 38px; line-height: 38px; float: left"
        v-if="iserrordisplay"
      >
        <p style="color: #5a5854">
          由于数据问题导致本次更新失败，请下载报错文件
          <a @click="GetErrorFile" style="color: red; cursor: pointer"
            >报错文件</a
          >
        </p>
      </div>
      <div style="float: right">
        <el-button
          class="button-search"
          style="margin-left: 10px"
          @click="search"
          >Search</el-button
        >
        <el-button class="button-search" @click="exportdata">Export</el-button>
        <el-button class="button-search" v-if="isdisplay" @click="click"
          >Upload</el-button
        >
        <el-button class="button-search" v-if="isadmin" @click="Lock(1)"
          >Lock</el-button
        >
        <el-button class="button-search" v-if="isadmin" @click="Lock(2)"
          >Unlock</el-button
        >
        <Taskupload
          @closeDialog="close"
          @Upload="Upload"
          v-if="showDialog"
          :message="UploadMessage"
        ></Taskupload>
      </div>
    </div>
    <div class="content_title">
      <div class="div-pagination">
        <p
          style="
            text-align: right;
            font-size: 13px;
            height: 32px;
            line-height: 32px;
            color: #606266;
            width: 90%;
          "
        >
          {{ strnum }}
        </p>
        <el-pagination
          background
          ref="multipleTablePagination"
          @current-change="pagingChange"
          :current-page.sync="currentPage"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total"
          style="text-align: right"
        ></el-pagination>
      </div>
      <div class="table-content">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
          :data="tableData"
          border
          fit
          tooltip-effect="dark"
          :header-cell-style="tableHeaderCell"
          :cell-style="tableCell"
          :cell-class-name="cellClassName"
          :height="tableHeight"
        >
          <el-table-column
            type="selection"
            width="50px"
            style="text-align: center"
          ></el-table-column>
          <af-table-column
            v-for="item in columns"
            :key="item.field_Name"
            :align="flexWidth(item.column_Name, item.field_Name)"
            :prop="item.field_Name"
            :label="item.column_Name"
            show-overflow-tooltip
          ></af-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Taskupload from "@/components/TaskUpload.vue";
import Download from "@/common/js/Download.js";
export default {
  data() {
    return {
      multipleSelection: [],
      currentPage: 1,
      checks: [],
      total: 0,
      locked: 0,
      unlocked: 0,
      page: "",
      pagenum: 20,
      loading: true,
      tableData: [],
      Field_Names: [],
      Column_Names: [],
      columns: [],
      showDialog: false,
      dt: [],
      dt_cs: [],
      isdisplay: false,
      mulchoice: [],
      POSCode: "",
      ProjectCode: "",
      ProvinceOptions: [],
      CityOptions: [],
      Provinces: [],
      Citys: [],
      ChannelOptions: [],
      Channels: [],
      SubChannelOptions: [],
      SubChannels: [],
      FormatOptions: [],
      Formats: [],
      TeamOptions: [],
      Teams: [],
      GroupCustomerOptions: [],
      GroupCustomers: [],
      BusinessModelOptions: [],
      BusinessModels: [],
      RegionOptions: ["East", "North", "South", "West"],
      Regions: [],
      CityTierOptions: [],
      CityTiers: [],
      UploadMessage: "",
      searchFlag: false,
      isadmin: false,
      primary: "",
      strnum: "",
      errorfile: new ArrayBuffer(10),
      iserrordisplay: false,
      columnnames: [],
      POSStatus: [],
      POSStatusCheck: [],
      Action: [],
      ActionCheck: [],
      ProjectStatus: [],
      ProjectStatusCheck: [],
      summarybutton: "Summary-",
      isvosablesummary: true,
      summaryLoading: false,
      summaryTableData: [],
      summaryColumns: [
        {
          field_Name: "region",
          column_Name: "Region",
          width: 100,
        },
      ],
      currentregion: "",
    };
  },
  computed: {
    check_Teams: {
      get() {
        if (this.Teams.length === this.TeamOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_GroupCustomers: {
      get() {
        if (this.GroupCustomers.length === this.GroupCustomerOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_Channels: {
      get() {
        if (this.Channels.length === this.ChannelOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_SubChannels: {
      get() {
        if (this.SubChannels.length === this.SubChannelOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_Formats: {
      get() {
        if (this.Formats.length === this.FormatOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_BusinessModels: {
      get() {
        if (this.BusinessModels.length === this.BusinessModelOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_Regions: {
      get() {
        if (this.Regions.length === this.RegionOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_Provinces: {
      get() {
        if (this.Provinces.length === this.ProvinceOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_Citys: {
      get() {
        if (this.Citys.length === this.CityOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_CityTiers: {
      get() {
        if (this.CityTiers.length === this.CityTierOptions.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_POSStatusCheck: {
      get() {
        if (this.POSStatusCheck.length === this.POSStatus.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_ProjectStatusCheck: {
      get() {
        if (this.ProjectStatusCheck.length === this.ProjectStatus.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    check_Action: {
      get() {
        if (this.ActionCheck.length === this.Action.length) {
          return true;
        }
        return false;
      },
      set() {},
    },
    tableHeight: {
      get() {
        return window.innerHeight - 190;
      },
      set() {},
    },
  },
  methods: {
    handleSelectionChange(val) {
      if (this.primary.toLowerCase() == "poscode") {
        var arr = [];
        if (val != null && val.length > 0) {
          val.forEach((element) => {
            arr.push(element.poscode);
          });
        }
        this.multipleSelection = arr;
      } else if (this.primary.toLowerCase() == "projectcode") {
        var arr = [];
        if (val != null && val.length > 0) {
          val.forEach((element) => {
            arr.push(element.projectcode);
          });
        }
        this.multipleSelection = arr;
      }
    },
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.GetTaskPOS(pageIndex);
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    tableCell() {
      return "color: #5A5854;padding-left:4px";
    },
    tableCellSummary() {
      return "color: #5A5854;padding-left:4px;text-align:center;height:24px;padding:6px 0";
    },
    clicksummary() {
      this.isvosablesummary = !this.isvosablesummary;
      if (this.isvosablesummary) {
        this.summarybutton = "Summary-";
      } else {
        this.summarybutton = "Summary+";
      }
    },
    GetSumColumns() {
      this.$api
        .get("/CR/GetSumColumns", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            var summaryColumns = res.data.content;
            summaryColumns.forEach((element) => {
              this.summaryColumns.push({
                field_Name: element.toLowerCase(),
                column_Name: element,
                width: 100,
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetTaskPOS(pageIndex) {
      var provinces = [];
      var citys = [];
      if (this.Provinces.length > 0) {
        this.Provinces.forEach((element) => {
          provinces.push(this.ProvinceOptions.find((p) => p.id == element));
        });
      }
      if (this.Citys.length > 0) {
        this.Citys.forEach((element) => {
          citys.push(this.CityOptions.find((p) => p.id == element));
        });
      }

      this.$api
        .post(
          "/Task/GetTaskPOS",
          {
            ID: this.page,
            currentpage: pageIndex,
            page: this.pagenum,
            // list: this.mulchoice,
            posStatuss: this.POSStatusCheck,
            projectStatuss: this.ProjectStatusCheck,
            actions: this.ActionCheck,
            posCode: this.POSCode,
            projectCode: this.ProjectCode,
            teams: this.Teams,
            GroupCustomers: this.GroupCustomers,
            channels: this.Channels,
            subChannels: this.SubChannels,
            formats: this.Formats,
            businessModels: this.BusinessModels,
            regions: this.Regions,
            provinces: provinces,
            citys: citys,
            cityTiers: this.CityTiers,
          },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            this.total = res.data.total;
            this.tableData = res.data.content;
            this.loading = false;
            this.locked = res.data.locked;
            this.unlocked = res.data.unlocked;
            this.strnum =
              "Locked Data " +
              res.data.locked +
              " , Need Feedback " +
              res.data.unlocked +
              " , ";
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetOneTaskConfig() {
      this.$api
        .get("/Task/GetOneTaskConfig", { ID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.columns = res.data.content;
            this.Field_Names = [];
            this.Column_Names = [];
            res.data.content.forEach((element) => {
              this.Field_Names.push(element.field_Name);
              this.Column_Names.push(element.column_Name);
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    IsDisplay() {
      this.$api
        .get("/Task/IsDisplay", { TaskID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.isdisplay = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    click() {
      this.showDialog = true;
    },
    exportdata() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      var provinces = [];
      var citys = [];
      if (this.Provinces.length > 0) {
        this.Provinces.forEach((element) => {
          provinces.push(this.ProvinceOptions.find((p) => p.id == element));
        });
      }
      if (this.Citys.length > 0) {
        this.Citys.forEach((element) => {
          citys.push(this.CityOptions.find((p) => p.id == element));
        });
      }
      this.$api
        .post(
          "/Task/GetTaskExport/",
          {
            ID: this.page,
            currentpage: 1,
            page: this.pagenum,
            // list: this.mulchoice,
            posStatuss: this.POSStatusCheck,
            projectStatuss: this.ProjectStatusCheck,
            actions: this.ActionCheck,
            posCode: this.POSCode,
            projectCode: this.ProjectCode,
            teams: this.Teams,
            GroupCustomers: this.GroupCustomers,
            channels: this.Channels,
            subChannels: this.SubChannels,
            formats: this.Formats,
            businessModels: this.BusinessModels,
            regions: this.Regions,
            provinces: provinces,
            citys: citys,
            cityTiers: this.CityTiers,
          },
          "arraybuffer"
        )
        .then((res) => {
          this.$message({
            // message: "只可导出可编辑的数据" + this.unlocked + "条",
            message: "导出成功，共" + this.total + "条数据",
            type: "success",
          });
          // let filename = "Task.xlsx";
          // Download(res.data, filename);
          this.$api
            .get("/Task/GetTaskName/", { ID: this.page }, (res) => {})
            .then((ress) => {
              if (ress.data.status) {
                debugger;
                let filename =
                  ress.data.content + this.timestampToTime() + ".xlsx";
                Download(res.data, filename);
                loading.close();
              } else {
                this.$message({ message: res.data.message, type: "warring" });
              }
            });
          loading.close();
        })
        .catch((e) => {
          this.$message({ message: err.message, type: "warring" });
          loading.close();
        });
      loading.close();
    },
    timestampToTime() {
      var date = new Date();
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      // var m =
      //   date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // var s =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    close() {
      this.showDialog = false;
    },
    GetErrorFile() {
      Download(this.errorfile, "UploadErrors.xlsx");
    },
    Upload(inputarea) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      inputarea = inputarea.replace(/^\s+|\s+$/g, "");
      if (this.isEmpty(inputarea)) {
        this.$message({
          message: "Please input upload detail",
          type: "error",
        });
        return;
      }
      this.$api
        .post(
          "/Task/Upload/",
          { UploadData: inputarea, TaskID: this.page, flag: 0 },
          "arraybuffer"
        )
        .then((res) => {
          let filename = eval(res.headers);

          if (filename["content-type"] == "application/octet-stream") {
            this.$message({
              message: "更新失败!",
              type: "error",
            });
            this.errorfile = res.data;
            this.iserrordisplay = true;
          } else {
            var error = String.fromCharCode.apply(
              null,
              new Uint8Array(res.data)
            );
            var oo = JSON.parse(error);
            if (oo.status) {
              this.GetTaskPOS(this.currentPage);
              this.$message({
                message: oo.message + "条数据已上传成功!",
                type: "success",
              });
              this.iserrordisplay = false;
            } else {
              this.$message({
                message: oo.message,
                type: "fail",
              });
            }
          }
          loading.close();
        });
      loading.close();
    },
    GetSP_TaskCustomDatas() {
      this.$api
        .get("/Task/GetSP_TaskCustomDatas", {}, (res) => {})
        .then((res) => {
          this.dt = res.data.table;
          this.dt_cs = res.data.list;
        });
    },
    MulChoiceColumn() {
      this.$api
        .get("/Task/MulChoiceColumn", { TaskID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.mulchoice = res.data.content;
            if (this.mulchoice != null && this.mulchoice.length > 0) {
              this.mulchoice.forEach((element) => (element.checks = []));
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetTeam() {
      this.$api
        .get("/Task/GetTeam", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.TeamOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetGroupCustomer() {
      this.$api
        .get("/Task/GetGroupCustomers", { ID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.GroupCustomerOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetChannel() {
      this.$api
        .get("/Task/GetChannel", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.ChannelOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetSubChannel() {
      if (this.Channels.length > 0) {
        this.$api
          .post("/Task/GetSubChannel", { strs: this.Channels }, (res) => {})
          .then((res) => {
            if (res.data.status) {
              this.SubChannelOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          });
      } else {
        this.SubChannelOptions = [];
        this.SubChannels = [];
        this.FormatOptions = [];
        this.Formats = [];
      }
    },
    GetFormat() {
      if (this.SubChannels.length > 0) {
        this.$api
          .post("/Task/GetFormat", { strs: this.SubChannels }, (res) => {})
          .then((res) => {
            if (res.data.status) {
              this.FormatOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          });
      } else {
        this.FormatOptions = [];
      }
    },
    GetBusinessModel() {
      this.$api
        .get("/Task/GetBusinessModel", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.BusinessModelOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    InitBase() {
      this.$api
        .get("/Task/Init", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            if (!this.isEmpty(res.data.region)) {
              this.Regions.push(res.data.region);
              this.GetProvinces();
            }
            if (!this.isEmpty(res.data.team)) {
              this.Teams.push(res.data.team);
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetProvinces() {
      if (this.Regions.length > 0) {
        this.$api
          .post("/Task/GetProvinces", { strs: this.Regions }, (res) => {})
          .then((res) => {
            if (res.data.status) {
              this.ProvinceOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          });
      } else {
        this.Provinces = [];
        this.ProvinceOptions = [];
        this.CityOptions = [];
        this.Citys = [];
      }
    },
    GetCitys() {
      if (this.Provinces.length > 0) {
        this.$api
          .post("/Task/GetCitys", { ids: this.Provinces }, (res) => {})
          .then((res) => {
            if (res.data.status) {
              if (res.data.content && res.data.content.length > 0) {
                let tmp = res.data.content.sort((a, b) => {
                  return a.nameEN.charCodeAt(0) - b.nameEN.charCodeAt(0);
                });
                this.CityOptions = tmp;
              } else {
                this.CityOptions = [];
              }
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          });
      } else {
        this.CityOptions = [];
        this.Citys = [];
      }
    },
    GetCityTier() {
      this.$api
        .get("/Task/GetCityTier", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.CityTierOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetTaskColumns() {
      this.$api
        .get("/Task/GetTaskColumns", { ID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.UploadMessage = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetColumnNames() {
      this.$api
        .get("/Task/GetColumnNames", { ID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.columnnames = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    isDisabled(name) {
      if (!this.columnnames.length) return true;
      if (this.columnnames.find((p) => p === name)) {
        return false;
      } else {
        return true;
      }
    },
    search() {
      this.currentPage = 1;
      this.GetTaskPOS(1);
    },
    flexWidth(label, prop) {
      if (prop === "posfullnamecn" || prop === "posfullnameen") {
        return "left";
      } else {
        return "center";
      }
    },
    keyDown(e) {
      if (e.ctrlKey && e.keyCode == 13) {
        //用户点击了ctrl+enter触发
        this.search();
      }
    },
    selectAll_Teams(checked) {
      if (checked) {
        this.Teams = this.TeamOptions.map((d) => d);
      } else {
        this.Teams = [];
      }
    },
    selectAll_GroupCustomers(checked) {
      if (checked) {
        this.GroupCustomers = this.GroupCustomerOptions.map((d) => d);
      } else {
        this.GroupCustomers = [];
      }
    },
    selectAll_Channels(checked) {
      if (checked) {
        this.Channels = this.ChannelOptions.map((d) => d);
      } else {
        this.Channels = [];
      }
      this.GetSubChannel();
    },
    selectAll_SubChannels(checked) {
      if (checked) {
        this.SubChannels = this.SubChannelOptions.map((d) => d);
      } else {
        this.SubChannels = [];
      }
      this.GetFormat();
    },
    selectAll_Formats(checked) {
      if (checked) {
        this.Formats = this.FormatOptions.map((d) => d);
      } else {
        this.Formats = [];
      }
    },
    selectAll_BusinessModels(checked) {
      if (checked) {
        this.BusinessModels = this.BusinessModelOptions.map((d) => d);
      } else {
        this.BusinessModels = [];
      }
    },
    selectAll_Regions(checked) {
      if (checked) {
        this.Regions = this.RegionOptions.map((d) => d);
      } else {
        this.Regions = [];
      }
      this.GetProvinces();
    },
    selectAll_Provinces(checked) {
      if (checked) {
        this.Provinces = this.ProvinceOptions.map((d) => d.id);
      } else {
        this.Provinces = [];
      }
      this.GetCitys();
    },
    selectAll_Citys(checked) {
      if (checked) {
        this.Citys = this.CityOptions.map((d) => d.id);
      } else {
        this.Citys = [];
      }
    },
    selectAll_CityTiers(checked) {
      if (checked) {
        this.CityTiers = this.CityTierOptions.map((d) => d);
      } else {
        this.CityTiers = [];
      }
    },
    selectAll_POSStatus(checked) {
      if (checked) {
        this.POSStatusCheck = this.POSStatus.map((d) => d);
      } else {
        this.POSStatusCheck = [];
      }
    },
    selectAll_ProjectStatus(checked) {
      if (checked) {
        this.ProjectStatusCheck = this.ProjectStatus.map((d) => d);
      } else {
        this.ProjectStatusCheck = [];
      }
    },
    selectAll_Action(checked) {
      if (checked) {
        this.ActionCheck = this.Action.map((d) => d);
      } else {
        this.ActionCheck = [];
      }
    },
    isEmpty(obj) {
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
    GetPrimary(page) {
      this.$api
        .get("/Task/GetPrimary/", { ID: page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.primary = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        });
    },
    Lock(flag) {
      var content = "";
      if (this.multipleSelection.length > 0) {
        if (flag == 1) {
          for (var i = 0; i < this.multipleSelection.length; i++) {
            content += this.multipleSelection[i] + "\tN\n";
          }
        } else {
          for (var i = 0; i < this.multipleSelection.length; i++) {
            content += this.multipleSelection[i] + "\tY\n";
          }
        }
      } else {
        this.$message({
          type: "error",
          message: "Please select data",
        });
        return false;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$api
        .post(
          "/Task/Upload/",
          { UploadData: content, TaskID: this.page, flag: 1 },
          "arraybuffer"
        )
        .then((res) => {
          let filename = eval(res.headers);

          if (filename["content-type"] == "application/octet-stream") {
            this.$message({
              message: "Import Failed,Please download error report!",
              type: "error",
            });
            Download(res.data, "UploadErrors.xlsx");
          } else {
            var error = String.fromCharCode.apply(
              null,
              new Uint8Array(res.data)
            );
            var oo = JSON.parse(error);
            if (oo.status) {
              this.GetTaskPOS(this.currentPage);
              if (flag == 1) {
                this.$message({
                  message: "Lock Successfully!",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "Unlock Successfully!",
                  type: "success",
                });
              }
            } else {
              this.$message({
                message: oo.message,
                type: "fail",
              });
            }
          }
          loading.close();
        });
      loading.close();
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (row.status) {
        return "unlocked";
      } else {
        return "locked";
      }
    },
    GetPOSStatus() {
      this.$api
        .get("/Task/GetPOSStatus", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.POSStatus = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetAction() {
      this.$api
        .get("/Task/GetAction", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.Action = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetProjectStatus() {
      this.$api
        .get("/Task/GetProjectStatus", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.ProjectStatus = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    QuantityStatistics() {
      this.$api
        .get("/Task/QuantityStatistics", { ID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.summaryTableData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
  },
  components: {
    Taskupload,
  },
  mounted() {
    this.$api
      .get("/Login/IsAdmin/", {}, (res) => {})
      .then((res) => {
        this.isadmin = res.data;
      });
    this.$nextTick(() => {
      this.page = this.$route.params.ID;
      this.GetPrimary(this.page);
      this.GetTaskPOS(1);
      this.GetOneTaskConfig();
      this.IsDisplay();
      // this.MulChoiceColumn();
      this.InitBase();
      this.GetChannel();
      this.GetTeam();
      this.GetGroupCustomer();
      this.GetBusinessModel();
      this.GetCityTier();
      this.GetTaskColumns();
      this.GetColumnNames();
      this.GetPOSStatus();
      this.GetAction();
      this.GetProjectStatus();
      this.QuantityStatistics();
      this.GetSumColumns();
      //this.GetSP_TaskCustomDatas();
    });
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.content_title {
  margin: auto;
  width: 90%;
  text-align: center;
  margin-top: 10px;
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
}
.d-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
  margin: auto;
  width: 95%;
  &.d-flex-first {
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .flex-item {
    width: 20%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-right: 10px;
    overflow: hidden;
    height: 40px;
    margin-bottom: 15px;
    .label {
      padding-right: 5px;
      padding-left: 10px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: right;
      height: 40px;
      width: 18%;
      font-size: 13px;
      white-space: normal;
    }
  }
}
.summary {
  width: 90%;
  margin: auto;
  margin-bottom: 20px;
}
.div-pagination {
  margin-bottom: 10px;
  text-align: right;
  margin-top: 10px;
  display: flex;
}
.unlocked {
  background-color: #fff;
}
.locked {
  background-color: #e6a23c;
}
</style>

<style lang="scss">
.el-table .cell,
.el-table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0px !important;
}

.table-content {
  .el-table th {
    // padding: 0;
    white-space: nowrap;
    min-width: fit-content;
  }
  .el-table td {
    // padding: 1px;
    white-space: nowrap;
    width: fit-content;
  }
  .el-card__body {
    padding: 10px;
  }
  .el-table .cell {
    white-space: nowrap;
    width: fit-content;
    margin: 0 auto;
  }
}
</style>

<style>
.d-flex .el-checkbox {
  padding-left: 0px !important;
  text-align: left !important;
}
.task-detail .unlocked {
  background-color: #fff;
}
.task-detail .locked {
  background-color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/TaskDetail.vue